module.exports = __webpack_public_path__ + "img/0766-exit-left.04bd6bdf.svg";